/* global angular */

import complianceGauge from './complianceGauge';
import convertToNumber from './convertToNumber';
import courseStatusLabel from './courseStatusLabel';
import externalStatusLabel from './externalStatusLabel';
import credits from './credits';
import dateRangeValidation from './dateRangeValidation';
import dropdownPosition from './dropdownPosition';
import fullScroll from './fullScroll';
import googleplace from './googleplace';
import hourFormat from './hourFormat';
import howDoI from './howDoI';
import icheck from './icheck';
import jotFormEmbed from './jotForm';
import minimalizaSidebar from './minimalizaSidebar';
import pageTitle from './pageTitle';
import progressStatusLabel from './progressStatusLabel';
import progressValue from './progressValue';
import sideNavigation from './sideNavigation';
import spinner from './spinner';
import spinnerSm from './spinnerSm';
import textEditor from './textEditor';
import title from './title';
import topnav from './topnav';
import uniqueId from './uniqueId';
import eventStyle from './eventStyle';
import onFilter from './onFilter';
import timeSelect from './timeSelect';
import eventStatusLabel from './eventStatusLabel';
import minuteFormat from './minuteFormat';
import userStatus from './userStatus';
import wysiwygContent from './wysiwygContent';
import proDatePicker from './proDatePicker';
import marketplaceLabel from './marketplaceLabel';

export default angular
  .module('app.directives', [])
  .directive('title', title)
  .directive('complianceGauge', complianceGauge)
  .directive('convertToNumber', convertToNumber)
  .directive('courseStatusLabel', courseStatusLabel)
  .directive('externalStatusLabel', externalStatusLabel)
  .directive('credits', credits)
  .directive('dateRangeValidation', dateRangeValidation)
  .directive('hourFormat', hourFormat)
  .directive('proDatePicker', proDatePicker)
  .directive('dropdownPosition', dropdownPosition)
  .directive('fullScroll', fullScroll)
  .directive('googleplace', googleplace)
  .directive('howDoI', howDoI)
  .directive('icheck', icheck)
  .directive('jotFormEmbed', jotFormEmbed)
  .directive('minimalizaSidebar', minimalizaSidebar)
  .directive('pageTitle', pageTitle)
  .directive('progressStatusLabel', progressStatusLabel)
  .directive('progressValue', progressValue)
  .directive('sideNavigation', sideNavigation)
  .directive('spinner', spinner)
  .directive('spinnerSm', spinnerSm)
  .directive('textEditor', textEditor)
  .directive('topnav', topnav)
  .directive('uniqueId', uniqueId)
  .directive('eventStyle', eventStyle)
  .directive('onFilter', onFilter)
  .directive('timeSelect', timeSelect)
  .directive('eventStatusLabel', eventStatusLabel)
  .directive('userStatus', userStatus)
  .directive('wysiwygContent', wysiwygContent)
  .directive('minuteFormat', minuteFormat)
  .directive('marketplaceLabel', marketplaceLabel).name;



// WEBPACK FOOTER //
// ./src/app/directives/index.js